export const ME_QUERY = `
  query GetMeMarcom($eventId: ID, $withActiveEventUser: Boolean!) {
    me {
      ...UserProfile
      activeEventUser: activeEventUserForEvent(eventId: $eventId)
        @include(if: $withActiveEventUser) {
        ...ActiveEventUser
      }
      eventMemberships: activeEventUsers {
        ...EventMembership
      }
    }
  }

  fragment UserProfile on User {
    id
    firstName
    lastName
    superAdmin
    avatar {
      id
      url
    }
  }

  fragment ActiveEventUser on EventUser {
    id
    status
    event {
      id
      website
      info {
        eventDisplayName
        eventMonogram
        location
        finalizedDate {
          ...Date
        }
      }
    }
  }

  fragment EventMembership on EventUser {
    id
    status
    event {
      id
      website
    }
  }

  fragment Date on Date {
    timestamp
    timezone
    milliseconds
  }
`;
